// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__27Ix_","boxTitle":"Qualiphy_boxTitle__2yHKn","box":"Qualiphy_box__11C1q","toggleWrap":"Qualiphy_toggleWrap__2iFY_"};